import React from 'react';
import Room from './Room';
import roomsStyles from './rooms.module.sass';

export default props => {

  const { acf, addClasses } = props
  const rooms = Object.values(acf.rooms)[0]  // Rooms is received as an object rather than an array

  return (
    <div className={[roomsStyles.rooms, addClasses].join(' ')}>
      <div className={roomsStyles.content}>
        <ul className={roomsStyles.list}>
          {
            rooms && rooms.map((room, index) => (
              <Room orientation={index % 0 ? 'even' : 'odd'} room={room} key={room.room_name} />
            ))
          }
        </ul>
      </div>
    </div>
  )

};